export interface IGpsItemsForCentralRecords {
    id: number,
    gpsDeviceId: number,
    gpsNumber: number
    swapNumber: string,
    matchOfferDate: string,
    targetSurgeryDate: string,
    isCancelled: boolean,
    donorCenter: string,
    recipientCenter: string,
    rdnCenter: string,
    donorTransportMethod: string,
    donorTransportMethodBackUp: string,
    gpsStatus: string,
    gpsComments: string,
    returnedOn: string
}